// 알림
//
// 배지 숫자와 목록을 함께 다룬다. 배지는 /count 만 치고(COUNT 한 번),
// 목록은 시트를 열 때만 가져온다 — 폴링이 목록까지 끌어오면 낭비다.

import http from '@/utils/http'

export const state = {
  notifications: [],
  notificationUnread: 0,
  notificationCursor: null,
  notificationLoading: false
}

export const mutations = {
  SET_NOTIFICATIONS(state, { items, unread, nextCursor, append = false }) {
    state.notifications = append ? [...state.notifications, ...items] : items
    if (unread != null) state.notificationUnread = unread
    state.notificationCursor = nextCursor ?? null
  },

  SET_NOTIFICATION_UNREAD(state, n) {
    state.notificationUnread = Number(n) || 0
  },

  SET_NOTIFICATION_LOADING(state, v) {
    state.notificationLoading = v
  },

  MARK_NOTIFICATION_READ(state, id) {
    const n = state.notifications.find((x) => Number(x.id) === Number(id))
    if (n && !n.readAt) {
      n.readAt = new Date().toISOString()
      state.notificationUnread = Math.max(0, state.notificationUnread - 1)
    }
  },

  MARK_ALL_NOTIFICATIONS_READ(state) {
    const now = new Date().toISOString()
    state.notifications.forEach((n) => { if (!n.readAt) n.readAt = now })
    state.notificationUnread = 0
  }
}

export const actions = {
  /** 배지용 — 숫자만 */
  async fetchNotificationCount({ commit }) {
    const res = await http.get('/api/notifications/count')
    commit('SET_NOTIFICATION_UNREAD', res.data.unread)
    return res.data.unread
  },

  /** 목록 — 시트를 열 때만 */
  async fetchNotifications({ commit, state }, { append = false } = {}) {
    commit('SET_NOTIFICATION_LOADING', true)
    try {
      const params = { limit: 20 }
      if (append && state.notificationCursor) params.before = state.notificationCursor
      const res = await http.get('/api/notifications', { params })
      commit('SET_NOTIFICATIONS', {
        items: res.data.notifications || [],
        unread: res.data.unread,
        nextCursor: res.data.nextCursor,
        append
      })
      return res.data
    } finally {
      commit('SET_NOTIFICATION_LOADING', false)
    }
  },

  async markNotificationRead({ commit }, id) {
    // 낙관적으로 먼저 반영한다 — 탭하고 화면이 넘어가는 사이 숫자가 늦게 줄면 안 눌린 것처럼 보인다
    commit('MARK_NOTIFICATION_READ', id)
    try {
      await http.post(`/api/notifications/${id}/read`)
    } catch {
      // 실패해도 되돌리지 않는다. 다음 폴링이 서버 값으로 교정한다.
    }
  },

  async markAllNotificationsRead({ commit }) {
    commit('MARK_ALL_NOTIFICATIONS_READ')
    try {
      await http.post('/api/notifications/read-all')
    } catch { /* 다음 폴링이 교정 */ }
  }
}

export const getters = {
  notificationUnread: (state) => state.notificationUnread
}
